
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jugadores/[...slug]",
      function () {
        return require("private-next-pages/jugadores/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jugadores/[...slug]"])
      });
    }
  